import { render } from "./ServerError.vue?vue&type=template&id=619e50cd&scoped=true"
import script from "./ServerError.js?vue&type=script&lang=js"
export * from "./ServerError.js?vue&type=script&lang=js"

import "./style.css?vue&type=style&index=0&id=619e50cd&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-619e50cd"]])

export default __exports__